import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "../Modal";
import { useTranslation } from "react-i18next";
// import { useDispatch } from "react-redux";
// import formatTime from "../../hooks/formatTime";
// import { logout } from '../../features/auth/authSlice.js'
import SkeletonLoader from "../../components/skeletonLoader.jsx";
import ProgressBar from "../../components/progressBar.jsx";

const Module = ({ dir = "ltr" }) => {

  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const userName = profileData?.name;

  // const timerRef = useRef(null);
  const location = useLocation();
  const { moduleId } = location.state || {};
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [showMessage, setShowMessage] = useState(false)
  const [modules, setModules] = useState([]);
  const [completed, setCompleted] = useState(() => {
    const saved = localStorage.getItem("completedChapters");
    return saved ? JSON.parse(saved) : [];
  });
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation()
  const [certificatePopup, setCertificatePopup] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // const [certificateGenerateLoading, setCertificateGenerateLoading] = useState(false);
  // const [progress, setProgress] = useState(0)
  // const dispatch = useDispatch()
  const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;

  // const handleSignOut = useCallback(() => {
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("profileData");
  //   sessionStorage.removeItem("conversation");
  //   sessionStorage.removeItem("currentSessionId");
  //   sessionStorage.removeItem("sessionNumber");
  //   sessionStorage.removeItem("sessions");
  //   dispatch(logout())
  //   navigate("/login");
  // }, [navigate, dispatch])

  const documents = modules[0]?.documents || [];
  const documentProgress = modules[0]?.documentProgress || [];

  // Check if all documents have status "completed"
  const allDocumentsCompleted =
    documents.length > 0 &&
    documents.every((_, index) =>
      documentProgress.some(
        (doc) => doc.documentIndex === index && doc.status === "completed"
      )
    );
  const token = localStorage.getItem("token");

  const query = new URLSearchParams(location.search);
  // const id = query.keys().next().value;
  const continueNext = query.get("continue");
  const chapterFromQuery = parseInt(query.get("chapter"));

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    localStorage.setItem("completedChapters", JSON.stringify(completed));
  }, [completed]);

  const updateQuizTime = async () => {
    try {
      const response = await axios.post(`${base_url}/module/update/user/progress`, {
        moduleProgressId: modules[0]?.userModuleProgressId || "",
        quizStartedAt: new Date()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response.data?.data;
      console.log('updateQuizTime ====>', data);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchCourse = useCallback(async () => {
    try {

      const response = await axios.get(
        `${base_url}/module/get-module-all-data/${moduleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = response.data?.data;

      setCourse(data.courseId);
      setModules([{
        _id: data._id,
        title: data.title,
        documents: data?.documents || [],
        documentProgress: data?.departments[0]?.module?.users[0]?.userModuleProgress[0]?.documentProgress || [],
        quizeAttempts: data?.departments[0]?.module?.users[0]?.quizzes[0]?.attempts || [],
        quiz: data.quizzes || null,
        description: data.description || "",
        timeInterval: data.courseId.timeInterval,
        createdAt: data.createdAt,
        courseId: data.courseId._id,
        document_show: data.is_show_document,
        progressBar: data?.departments[0]?.module?.users[0]?.progress_bar || 0,
        progressStatus: data?.departments[0]?.module?.users[0]?.userModuleProgress[0]?.status,
        userModuleProgressId: data?.departments[0]?.module?.users[0]?.userModuleProgress[0]?._id,
        showCertificate: data?.departments[0]?.module?.users[0]?.userModuleProgress[0]?.show_certificate,
        quizStartedAt: data?.departments[0]?.module?.users[0]?.userModuleProgress[0]?.quizStartedAt,
      }]);

      // handle returning from quiz
      if (continueNext === "next" && !isNaN(chapterFromQuery)) {
        setCompleted((prev) => [...new Set([...prev, chapterFromQuery])]);
      }
    } catch (error) {
      // if (error?.response?.status === 401) {
      //   handleSignOut();
      // }
      console.error("Error fetching course details:", error);
    } finally {
      setLoading(false);
    }
  }, [moduleId, token, chapterFromQuery, continueNext, base_url]);

  useEffect(() => {
    if (!moduleId) return;
    fetchCourse();
  }, [moduleId, fetchCourse]);

  const handleStartQuiz = (quizeID, CourseID, moduleID, moduleTitle) => {
    if (quizeID === undefined) {
      navigate("/lms/courses");
    } else {
      if (modules[0]?.quizStartedAt === null) {
        updateQuizTime()
      }
      localStorage.removeItem("quizSubmitted");
      localStorage.removeItem("quizResultData");
      navigate('/lms/quize', {
        state: {
          quizId: quizeID,
          courseId: CourseID,
          moduleId: moduleID,
          moduleProgressId: modules[0]?.userModuleProgressId,
          moduleTitle
        }
      })
    }
  }

    // Get sidebar state and handle responsive layout
  useEffect(() => {
    const updateSidebarState = () => {
      const sidebarState = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-open');
      setSidebarOpen(sidebarState === '1');
    };

    updateSidebarState();

    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    const observer = new MutationObserver(updateSidebarState);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Calculate responsive padding based on sidebar state and screen size
  const getContentPadding = () => {
    if (isMobile) {
      return "";
    }
    return sidebarOpen
      ? (dir === 'rtl' ? 'pr-64' : 'pl-64')
      : (dir === 'rtl' ? 'pr-20' : 'pl-20');
  };

  // if (loading)
  //   return (
  //     <div className="flex justify-center items-center py-20">
  //       <div className="w-12 h-12 border-4 border-[#A73884] border-t-transparent rounded-full animate-spin"></div>
  //     </div>
  //   );

  if (!course && !loading) {
    return (
      <div className="text-center py-10 text-red-500">Module not found.</div>
    );
  }

  const handleAction = () => {
    if (modules[0]?.quizeAttempts?.length >= 3) {
      setShowMessage(true)
    }
    else {
      handleStartQuiz(
        modules[0]?.quiz[0]?._id,
        modules[0]?.courseId,
        modules[0]?._id,
        modules[0]?.title
      )
    }
  }

  const handleNavigate = () => {
    navigate('/lms/courses')
  }

  const isPassed = modules[0]?.quizeAttempts?.find(({ isPassed }) => isPassed === true)

  async function HandleGenerateCertificate() {
    // setCertificateGenerateLoading(true)
    setCertificatePopup(true)
    // setProgress(0)
    try {

      const token = localStorage.getItem("token");
      const baseUrl = process.env.REACT_APP_LMS_APP_BASE_URL;

      const payload = {
        moduleId: moduleId,
        userName: userName,
        courseName: "English",
        score: isPassed?.score,
        status: isPassed?.isPassed ? "pass" : "fail",
        completionDate: getTodayDate(),
        cheifSignatureText: "Umer Aziz"
      };

      const response = await fetch(`${baseUrl}/certificate/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.success) {
        setCertificatePopup(false)
        // setCertificateGenerateLoading(false)
        // setProgress(100)
        window.open(result.data.s3Url, "_blank");
      } else {
        alert("Certificate generation failed: " + result.message);
        // setProgress((prevProgress) => prevProgress)
        setCertificatePopup(false)
        // setCertificateGenerateLoading(false)
      }

    } catch (err) {
      // setProgress((prevProgress) => prevProgress)
      setCertificatePopup(false)
      // setCertificateGenerateLoading(false)
      console.error(err);
    }
  }

  function showBgColor() {
    const status = modules[0]?.progressStatus;
    switch (status) {
      case "in_progress":
        return "bg-[linear-gradient(90deg,rgba(237,221,83,1)_0%,rgba(87,199,133,1)_0%,rgba(69,168,142,1)_66%,rgba(42,123,155,1)_100%)]";
      case "completed":
        return "bg-gradient-to-br from-[#A73884] to-[#803A85]";
      case "not_started":
        return "bg-[linear-gradient(90deg,rgba(131,58,180,1)_0%,rgba(252,176,69,1)_0%,rgba(253,29,29,1)_100%)]";
      default:
        return "";
    }
  }

  let rtlTextPosition = dir === "rtl" ? 'text-end' : 'text-start'
  let rtlFlexTextPosition = dir === "rtl" ? 'flex-row-reverse' : 'flex-row'

  return (
    <div className={`transition-all duration-300 ${getContentPadding()}`}>

      {/* Modal */}

      <Modal
        isOpen={showMessage}
        onClose={() => setShowMessage(false)}
        type={''}
        width={'w-[400px]'}
      >
        <h2 className="text-[16px] text-center font-medium mb-5 text-gray-900">
          You have reached the maximum number of attempts for this quiz. (3 attempts)
        </h2>
        <div className="flex justify-center">
          <button
            onClick={handleNavigate}
            className="text-[14px] px-4 py-2 bg-gray-200 text-gray-800 rounded-xl font-medium transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            Go to dashbaord
          </button>
        </div>
      </Modal>
      {certificatePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-lg relative">
            <button
              onClick={() => setCertificatePopup(null)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-900 text-xl font-medium"
            >
              &times;
            </button>
            {/* <h2 className="text-1xl font-medium mb-4">{certificateGenerateLoading && 'Your certificate is generating please wait...'}</h2> */}
            <div className="flex justify-center items-center">
              <div className="w-10 h-10 border-4 border-[#A73884] border-t-transparent rounded-full animate-spin"></div>
            </div>
          </div>
        </div>
      )}
      <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 p-4 z-10">
        {/* <div className="flex items-center justify-between"> */}
        <div className="flex items-center gap-4">
          <button onClick={() => navigate("/lms/courses")} style={{ backgroundColor: "#767676" }} className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center transition-all duration-300 cursor-pointer">
            <i className="ri-arrow-left-line text-xl text-white" />
          </button>
          <div>
            <h2 className="text-xl font-medium text-gray-900">
              {modules[0]?.title}
            </h2>
            {/* <p className="text-gray-600 mt-1">Section 1</p> */}
          </div>
        </div>
        {/* <div className="flex items-center gap-3">
            <span className="px-4 py-2 bg-purple-100 text-purple-700 border border-purple-200 rounded-xl text-sm font-medium whitespace-nowrap">
              {modules[0]?.progressBar || 0}% Complete
            </span>
          </div> */}
        {/* </div> */}
      </header>
      <div className="max-w-6xl mx-auto mt-8 px-4"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: 'calc(100vh - 190px)'
        }}
      >
        {loading ? (
          <SkeletonLoader count={1} className="mb-6 min-h-[520px] w-full" style={{ borderRadius: '2rem' }} />
        ) : (
          <>
            <div className="flex flex-col md:flex-row gap-10 px-4 md:px-0">
              {/* Left Section */}
              <div className="w-full md:w-1/2">
                <h2 className="text-xl font-medium text-gray-900 mb-6 md:mb-5">
                  {modules[0]?.title}
                </h2>
                <div
                  className="block group cursor-pointer relative"
                  key={modules[0]?._id}
                  data-discover="true"
                  style={{ animationDelay: "0ms" }}
                >
                  <div className="bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-3xl overflow-hidden hover:border-purple-300/50 hover:shadow-xl hover:shadow-purple-200/20 transition-all duration-300 group-hover:transform group-hover:scale-[1.02] h-full">
                    <div className="absolute mt-8 left-0" style={{ marginLeft: "-15px" }}>
                      <span
                        style={{ borderTopRightRadius: "20px", borderBottomRightRadius: "20px" }}
                        className="px-3 py-1 text-md font-semibold whitespace-nowrap ml-3 bg-white text-green-700 border border-green-200"
                      >
                        {modules[0]?.progressBar || 0}% {t('Completed')}
                      </span>
                    </div>
                    <div>
                      <div className={`flex items-start gap-4 mb-4 ${rtlFlexTextPosition}`}>
                        <div className={`w-full h-[270px] md:h-[200px] ${showBgColor()} shadow-lg group-hover:shadow-purple-300/50 transition-shadow duration-300`}>
                          {/* SVG here */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 673.76 360.09"
                            className="opacity-10 w-24 sm:w-auto"
                          >
                            <defs>
                              <style dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#fff;}" }} />
                            </defs>
                            <g id="Layer_2" data-name="Layer 2">
                              <g id="Layer_1-2" data-name="Layer 1">
                                <path
                                  fill="#F5F5F5"
                                  d="M203.41,117l-4.86,24.28L171.87,274.67a31.54,31.54,0,0,1-63.08,0L82.1,141.24,77.25,117a63.08,63.08,0,1,1,126.16,0Z"
                                />
                                <path
                                  fill="#F5F5F5"
                                  d="M329.57,243.13a63.08,63.08,0,1,1-126.16,0l4.85-24.28L235,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z"
                                />
                                <path
                                  fill="#F5F5F5"
                                  d="M461.05,63.08l-.75,9.84L429.51,328.55a31.54,31.54,0,1,1-63.08,0L335.67,72.92l-.75-9.84a63.07,63.07,0,1,1,126.13,0Z"
                                />
                                <path
                                  fill="#F5F5F5"
                                  d="M587.21,243.13a63.08,63.08,0,0,1-126.16,0l4.85-24.28L492.59,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z"
                                />
                                <circle fill="#F5F5F5" cx="31.54" cy="180.05" r="31.54" />
                                <circle fill="#F5F5F5" cx="642.22" cy="180.05" r="31.54" />
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <div className="px-6 pb-6">
                        <div className="mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                          <div className="flex items-center gap-6 flex-wrap">
                            <div className={`flex items-center ${rtlFlexTextPosition} text-sm text-gray-500`}>
                              <span className="flex items-center gap-2 whitespace-nowrap">
                                <i className="ri-file-text-line text-purple-500" />
                                {modules[0]?.document_show === true ? modules[0]?.documents?.length : 0} - {t("Documents")}
                              </span>
                            </div>
                            <span className="flex items-center gap-2 text-[#767676] whitespace-nowrap">
                              <i className="ri-time-line" />
                              {new Date(modules[0]?.createdAt).toLocaleDateString()}
                            </span>
                          </div>
                          {(isPassed || modules[0]?.showCertificate) && (
                            <button onClick={HandleGenerateCertificate} className="mt-2 md:mt-0 z-[100000000]">
                              <span className="px-4 sm:px-8 py-1 rounded-full text-md font-medium bg-[#3389a9] text-white whitespace-nowrap">
                                {t('View Certificate')}
                              </span>
                            </button>
                          )}
                        </div>
                        <div>
                          <ProgressBar progress={modules[0]?.progressBar || 0} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Vertical divider - hide on mobile */}
              <div className="hidden md:block border border-[#DDDDDD] self-stretch mx-4" />
              {/* Right Section */}
              <div className="w-full md:w-1/2">
                <div>
                  <div className={`flex justify-between items-center mb-2 ${rtlFlexTextPosition}`}>
                    <h3 className="text-xl font-medium text-gray-900 flex items-center gap-3">
                      {t("Course Documents & Materials")}
                    </h3>
                  </div>
                  {modules[0].document_show === true ? (
                    <p className={`text-lg mb-4 ${rtlTextPosition}`}>
                      {modules[0]?.description}
                    </p>
                  ) : (
                    <p className={`text-lg mb-4 ${rtlTextPosition}`}>
                      No document show
                    </p>
                  )}
                  <div className="grid grid-cols-1 gap-4 rtl-grid">
                    {modules[0]?.document_show === true &&
                      modules[0]?.documents?.length > 0 &&
                      modules[0]?.documents.map((docUrl, index) => {
                        const fileNameWithExt = decodeURIComponent(docUrl.split("/").pop());
                        const lastDot = fileNameWithExt.lastIndexOf(".");
                        const name = lastDot !== -1 ? fileNameWithExt.slice(0, lastDot) : fileNameWithExt;
                        const extension = lastDot !== -1 ? fileNameWithExt.slice(lastDot + 1).toUpperCase() : "N/A";
                        const formattedDate = new Date(modules[0].createdAt).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        });
                        const documentProgress = modules[0].documentProgress;
                        const isCompleted = documentProgress.some((doc) => doc.documentIndex === index && doc.status === "completed");
                        return (
                          <div
                            key={index}
                            className="block group cursor-pointer"
                            onClick={() =>
                              navigate(`/lms/dashboard/ContentView?${moduleId}`, {
                                state: {
                                  index,
                                  docUrl,
                                  name,
                                  quizeId: modules[0]?.quiz[0]?._id,
                                  courseId: modules[0]?.courseId,
                                  moduleId: modules[0]._id,
                                },
                              })
                            }
                            data-discover="true"
                            style={{ animationDelay: "0ms" }}
                          >
                            <div className="border-[1px] p-3 rounded-2xl transition-all duration-300 group-hover:transform group-hover:scale-[1.02]">
                              <div className="flex items-center gap-4">
                                {isCompleted ? (
                                  <div className="flex items-center justify-center bg-[#26B2C0] w-[60px] h-[60px] rounded-[10px] shrink-0">
                                    <i className="ri-check-line text-white text-[40px]" />
                                  </div>
                                ) : (
                                  <div className="flex items-center justify-center border border-gray bg-[#F5F6F7] w-[60px] h-[60px] rounded-[10px] shrink-0" />
                                )}
                                <div className="flex-1 min-w-0">
                                  <h4 className="font-medium text-gray-900 text-base mb-1 group-hover:text-purple-700 transition-colors line-clamp-1">
                                    {name}
                                  </h4>
                                  <div className="flex items-center gap-4 text-xs text-gray-500 flex-wrap">
                                    <span className="flex items-center gap-1 whitespace-nowrap">
                                      <i className="ri-calendar-line text-purple-500" />
                                      {formattedDate}
                                    </span>
                                    <span className="flex items-center gap-1 whitespace-nowrap">
                                      <i className="ri-file-line text-purple-500" />
                                      {extension}
                                    </span>
                                  </div>
                                </div>
                                <i className="ri-arrow-right-line text-purple-500 text-xl group-hover:translate-x-1 transition-transform duration-300" />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="relative bg-[#F4F6F8] rounded-2xl px-6 py-8 flex flex-col md:flex-row items-center justify-between overflow-visible">
              {/* Left icon and text */}
              <div className="flex items-center gap-4 md:gap-6 z-10 mb-6 md:mb-0 w-full md:w-auto">
                <div className="flex items-center justify-center bg-[#B03B82] w-12 h-12 rounded-full text-white text-xl flex-shrink-0">
                  <i className="ri-check-line" />
                </div>
                <div>
                  <h4 className="text-gray-800 font-semibold text-lg">
                    {t("Ready to test your knowledge?")}
                  </h4>
                  <p className="text-gray-500 text-sm">
                    {t("Complete the course and take the quiz.")}
                  </p>
                </div>
              </div>

              {/* Center character silhouette */}
              <img
                src="https://static.readdy.ai/image/f7a3d5ae10bab158f7003a8471295347/bc4c0da2f776773bbeca808400bb1c90.png"
                alt="Character Silhouette"
                className="absolute left-1/2 -translate-x-1/2 top-[-50%] h-[180px] hidden md:block"
                style={{ userSelect: "none" }}
              />

              {/* Right button */}
              {modules[0].document_show === false ? (
                <button
                  onClick={handleAction}
                  className="z-10 px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap w-full md:w-auto bg-[#B03B82] text-white hover:shadow-lg"
                >
                  {t("Finish Course")}
                  <i className="ri-arrow-right-line ml-2" />
                </button>
              ) : (
                <button
                  onClick={handleAction}
                  disabled={!allDocumentsCompleted}
                  style={{ cursor: !allDocumentsCompleted && "not-allowed" }}
                  className={`z-10 px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap w-full md:w-auto
              ${allDocumentsCompleted
                      ? "bg-[#B03B82] text-white hover:shadow-lg"
                      : "bg-gray-400 text-gray-200 cursor-not-allowed"
                    }`}
                >
                  {t("Finish Course")}
                  <i className="ri-arrow-right-line ml-2" />
                </button>
              )}
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default Module;